export const BRAND = {
  name: "Accrue Metrics",
  tagline: "Supporting Firms Behind the Scenes",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_cpa-solutions/artifacts/qd9r8p86_7720416C-A31C-4378-ABB2-D4F95462C322.png",
  email: "info@accruemetrics.com",
  phone: "+91 (954) 083-4743",
  address: "A-55, Pocket 10, Dwarka, Delhi - 110077",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    id: "bookkeeping",
    title: "Bookkeeping",
    short: "Month-end clean books, every time.",
    description:
      "Reconciliations, AP/AR, payroll journal entries, and management-ready financials prepared by trained accountants — fully aligned with your firm's review workflow.",
    features: [
      "Daily/weekly transaction categorization",
      "Bank & credit card reconciliations",
      "AR/AP processing & vendor management",
      "Month-end close & financial reporting",
      "QuickBooks, Xero, NetSuite, Sage Intacct",
    ],
    image:
      "https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    accent: "navy",
  },
{
    id: "Tax-Return-Preparation-Support",
    title: "Tax Return Preparation Support",
    short: "Clean tax data. Ready for filing.",
    description:
      "Tax-ready data compilation, working papers, income computation support, and reconciliation of financials — prepared through a structured process aligned with your firm’s review and filing workflow.",
    features: [
        "Compilation and organization of tax-relevant financial data",
        "Preparation of working papers and supporting schedules",
        "Income computation based on available records",
        "Reconciliation of financials with tax data",
        "Coordination support for review and filing",
    ],
    image:
      "https://images.unsplash.com/photo-1772588627342-5ec373e236d8?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    accent: "navy",
  },
{
    id: "Audit-Support-Services",
    title: "Audit Support Services",
    short: "Audit-ready data, structured for review",
    description:
      "Audit-ready data preparation, supporting schedules, reconciliations, and assistance in audit queries — delivered through a structured process aligned with your firm’s audit and review workflow.",
    features: [
        "Preparation of audit-ready financial data and schedules",
        "Reconciliation of key accounts and balances",
        "Compilation of supporting documents and working papers",
        "Assistance in audit query resolution and data requests",
        "Coordination support for audit workflows and timelines",
    ],
    image:
      "https://images.unsplash.com/photo-1714974528693-f77f6fcc56af?q=80&w=1032&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    accent: "navy",
  },
  {
    id: "process-automation",
    title: "Process Automation",
    short: "Streamline what you do every month.",
    description:
      "We map your existing workflows and rebuild them with automated bank feeds, document collection, intelligent categorization, and review checklists — measured by hours returned to your firm.",
    features: [
      "Workflow audit & process mapping",
      "Automated client document collection",
      "Bank feed and rule-based categorization",
      "Review & approval workflow design",
      "Integration with Karbon, Canopy, Jetpack",
    ],
    image:
      "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzJTIwYWJzdHJhY3QlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzc3NjQ2MjcxfDA&ixlib=rb-4.1.0&q=85",
    accent: "gold",
  },
  {
    id: "finance-ai",
    title: "Finance AI Agents",
    short: "AI that drafts, you review.",
    description:
      "Custom AI agents for transaction coding, reconciliation drafts, anomaly flags, and client emails — supervised by our accountants and aligned with your firm's standards before anything reaches the client.",
    features: [
      "Auto-coded transactions with confidence scores",
      "Anomaly & duplicate detection",
      "Draft client correspondence & memos",
      "GL variance analysis at month-end",
      "Human-in-the-loop oversight on every output",
    ],
    image:
      "https://images.unsplash.com/photo-1717343655329-e08427177978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBnbGFzcyUyMG9mZmljZSUyMGJ1aWxkaW5nJTIwYWJzdHJhY3R8ZW58MHx8fHwxNzc3NjQ2MjcxfDA&ixlib=rb-4.1.0&q=85",
    accent: "navy",
  },
];

export const INDUSTRIES = [
  {
    name: "Tax & Compliance Firms",
    blurb:
      "Year-round books that arrive ready for tax prep. We close clean so your CPAs spend less time fixing and more time advising.",
  },
  {
    name: "Audit & Assurance",
    blurb:
      "PBC list preparation, schedule reconciliation, and supporting workpapers — quietly handled before fieldwork begins.",
  },
  {
    name: "Advisory & CFO Services",
    blurb:
      "Management reporting packages, cash forecasts, and KPI dashboards your advisors can deliver to clients without the build time.",
  },
  {
    name: "Accounting & Consulting",
    blurb:
      "Outsourced full-charge bookkeeping for your client portfolio — billed cleanly so you keep your margin and your time.",
  },
  {
    name: "Real Estate & Property",
    blurb:
      "Property-level books, intercompany allocations, and owner statements across multi-entity portfolios.",
  },
  {
    name: "Professional Services",
    blurb:
      "Project accounting, time-and-expense reconciliation, and revenue recognition for law firms, agencies, and consultancies.",
  },
];

export const STATS = [
  { value: "60+", label: "CPA Firms Supported" },
  { value: "10,000+", label: "Monthly Reconciliations" },
  { value: "65%", label: "Avg. Time Saved on Close" },
  { value: "24h", label: "Typical Turnaround" },
];

export const SERVICE_OPTIONS = [
  "Bookkeeping",
  "Tax Return Preparation Support",
  "Audit Support Services",
  "Process Automation",
  "Finance AI Agents",
  "All Services",
  "Not Sure Yet",
];

export const FIRM_SIZES = [
  "Solo / 1 partner",
  "2–10 staff",
  "11–50 staff",
  "51–200 staff",
  "200+ staff",
];
